import React from 'react';
import PropTypes from 'prop-types';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonLabel,
  IonImg,
  IonList,
  IonItem,
  IonAvatar,
  IonSpinner
} from '@ionic/react';
import { connect } from 'react-redux'
import './Progress.css';

import ProgressActions from '../../../actions/progress';
import { RESOURCES } from '../../../constants/system';
import ErrorAlert from '../../../components/ErrorAlert';

interface Props {
  getChilds: any;
}

interface ClassState {
  data: any;
}

class Progress extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data}
  }

  componentDidMount(){
    this.props.getChilds({pag: '1', show: '10', search: ''}, "get_childs");
  }

  componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { users, loading, error, error401 } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>{ !error && !error401 && !loading ? "Progreso" : error || error401 ? "Error en la petición" : "Cargando..." }</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
        <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
        <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
        <h1 style={users.length === 0 && !loading && !error && !error401 ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
        <IonList style={error || error401 && !loading ? {display: "none"} : {display: "block"}}>
          {users.map((val:any, key:any) => {
            return (
            <IonItem key={key} href={`/progress/${ val.carnet }/info`}>
              <IonAvatar slot="start">
                <IonImg src={`${ RESOURCES }alumnos/${ val.imagen }`}/>
              </IonAvatar>
              <IonLabel>
                <h2>{val.alumno}</h2>
                <h3>{val.carnet}</h3>
                <p>{val.idmined}</p>
              </IonLabel>
            </IonItem>
            );
          })}
        </IonList>

        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getChilds: PropTypes.func.isRequired,
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChilds: (fields: any, typeOptions: string) => dispatch(ProgressActions.getChilds(fields, typeOptions))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Progress);
